import React, { Component } from 'react';
import DatePicker  from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ApiService from '../service/ApiService' ;


class PSpaceComponent extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedDevis : undefined,
            listeDevis : [],
            message : "",
            loading : false,
            isSuccess : true
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleOptionUsageChange = this.handleOptionUsageChange.bind(this);
        this.handleDatePermisChange = this.handleDatePermisChange.bind(this);
        this.handleDateMECChange = this.handleDateMECChange.bind(this);
        this.handleDateNaissanceChange = this.handleDateNaissanceChange.bind(this);
        this.modifierDevis = this.modifierDevis.bind(this);
       
    }

    componentDidMount() {
      this.reloadDevisList();
  }

  reloadDevisList() {
    this.setState({loading: true});
      ApiService.fetchDevis()
          .then((res) => {
              let isErr = res.data.errorMessage ? true : false;
              if (!isErr) {
              this.setState({listeDevis: res.data.result});
              this.setState({message: res.data.message});
              this.setState({isSuccess: true});
              this.setState({loading: false});
              } else {
                  this.setState({message: res.data.errorMessage});
                  this.setState({isSuccess: true, loading : false});
              }
          })
          .catch(error => {
              //console.log(error);
              this.setState({message: error.message});
              this.setState({isSuccess: false, loading : false});
          })
          ;
    }
    handleOptionUsageChange = changeEvent => {
      this.setState({
        usage: changeEvent.target.value
      });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }
    handleDateMECChange = date => {
          this.setState({
            dateMEC: date
          });
        };

    handleDatePermisChange = date => {
          this.setState({
            datePermis: date
          });
        };

    handleDateNaissanceChange = date => {
          this.setState({
            dateNaissance: date
          });
        };

    handleGarChange2(io) {
          let ename =  this.state.selectedDevis.garanties[io].code;
          let checked =  !this.state.selectedDevis.garanties[io].checked; 
          let newDevis = this.state.selectedDevis;
          ApiService.fetchPrimeByGarUsage(this.selectedDevis.usage, ename, this.va(ename))
          .then(res => {
              let isErr = res.data.errorMessage ? true : false;
              if (!isErr) {
                  let prime = res.data.result;
                  let primeNetteT = this.state.newDevis.primeNette;
                  if (checked) {
                    primeNetteT = primeNetteT + prime;
                  }
                  else {
                    primeNetteT = primeNetteT - prime;
                  }
                  newDevis.primeNette = primeNetteT;
                  newDevis.garanties[io].checked = checked;
                  this.setState({ selectedDevis : newDevis });
   
               } else {
                  this.setState({message: res.data.errorMessage});
                  this.setState({isSuccess: false});
               }
          }).catch(error => {
              //console.log(error);
              this.setState({ 
                  message : error.message
              });
          })
  
          
      }

      va  = (codeGar) => {
        if (codeGar === 'T') {
            return this.props.valeurNeuf;
        }
        else {
            if (codeGar === 'BDG') {
                return this.props.valeurGlaces;
            }
            else {
                return this.props.valeurVenale;
            }
        }

    }

    modifierDevis(devis) {


      let devisTemp = devis;
      if (devisTemp.dateMEC) {
          let datemec  = devisTemp.dateMEC;
          devisTemp.dateMEC= new Date(parseInt(datemec.substr(6,4)),
                                parseInt(datemec.substr(3,2)) -1,
                                parseInt(datemec.substr(0,2)));
      }
      if (devisTemp.dateNaissance){
        let datenais  = devisTemp.dateNaissance;
        devisTemp.dateNaissance= new Date(parseInt(datenais.substr(6,4)),
                              parseInt(datenais.substr(3,2)) -1,
                              parseInt(datenais.substr(0,2)));
    }

      if (devisTemp.datePermis){
        let datepermis  = devisTemp.datePermis;
        devisTemp.datePermis= new Date(parseInt(datepermis.substr(6,4)),
                              parseInt(datepermis.substr(3,2)) -1,
                              parseInt(datepermis.substr(0,2)));
    }


      let garanties = devis.garanties.slice();
      garanties.sort((a,b)=>{ return a.ordre-b.ordre;}); 
      devisTemp.garanties = garanties;
      this.setState({selectedDevis: devisTemp});
  }


    render() {

        return (
            <React.Fragment>
            {this.state.loading && ( 
            <div class="text-center container mb-4 mt-4">
            <div class="spinner-border text-danger" style={{"width": "4rem", "height": "4rem"}} role="status">
                <span class="sr-only">Chargement en cours...</span>
            </div>  
        </div>
            )}
            {!this.state.loading && !this.state.isSuccess &&(
                <div class="container mb-4 mt-4">
                  <div
                    className="alert alert-danger alert-dismissible fade show"
                    
                    style = {{'white-space': 'pre-wrap'}}
  
                    role="alert"
                  >
                    {this.state.isSuccess ? <strong>OK! </strong> : <strong>KO! </strong> }
                    {this.state.message}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              )}
              {!this.state.loading && this.state.isSuccess && (
                <React.Fragment>
                <div class="text-justify py-2">
                <div class="container">
                    <div class="row">
                    <div class="col-md-12">
                        <h4>Bienvenue à votre espace client</h4>
                    </div>
                    </div>
                </div>
                </div>
                <div class="py-3">
                <div class="container">
                  <div class="row">
                    <div class="col-md-12">
                      <ul class="nav nav-tabs nav-fill">
                        <li class="nav-item w-25 text-center"> <a href="{#}" class="active nav-link" data-toggle="pill" data-target="#tabtwo"><i class="fa fa-files-o"></i> Mes Devis</a> </li>
                        <li class="nav-item w-25 text-center" > <a href="{#}" class="nav-link" data-toggle="pill" data-target="#tabone"><i class="fa fa-user"></i> Mon Profile</a> </li>
                        <li class="nav-item w-25 text-center bg-light"> <a href="{#}" class="nav-link" data-toggle="pill" data-target="#tabfive"><i class="fa fa-trash"></i> Supprimer le compte</a> </li>
                      </ul>
                      <div class="tab-content m-2">

                        <div class="tab-pane fade show active" id="tabtwo" role="tabpanel">
                          <div class="row">
                            <div class="col-md-2 mt-2">
                              <ul class="list-group list-group-flush">
                                <li class="list-group-item list-group-item-action active text-center bg-info"><i class="fa mr-2 fa-car text-white fa-2x"></i><br/>Auto / Moto</li>
                                <li class="list-group-item list-group-item-action text-center"><i class="fa text-info mr-2 fa-home fa-2x"></i> Habitation</li>
                                <li class="list-group-item list-group-item-action text-center"><i class="fa text-info mr-2 fa-ship fa-2x"></i> Plaisance</li>
                              </ul>
                            </div>
                            <div class="col-md-10">
                            {this.state.selectedDevis && (
                              <React.Fragment>
                              <div class="row">
                                <div class="col-md-6">
                                  <h5 class="">Votre prime <font color="#6c757d"><span style={{'font-size': '15px'}}>en Mad</span></font>
                                  </h5>
                                </div>
                                <div class="col-md-6">
                                  <div class="blockquote">
                                    <p class="mb-0">{this.state.selectedDevis.primeNette} TTC</p>
                                    <div class="blockquote-footer">{this.state.selectedDevis.primeNette} HT</div>
                                  </div>
                                </div>
                                <div class="col-md-6" >
                                  <div class="card ">
                                    <div class="card-header">Risque assuré</div>
                                    <div class="card-body p-1">
                                      <form id="c_form-h" class="">
                                        <div class="form-group row"> <label for="usage" class="col-form-label col-6">Usage</label>
                                          <div class="col-6">
                                          <select class="form-control" id="usage" name="usage" value={this.state.selectedDevis.usage} onChange={this.handleChange}>
                                              <option value="">---Energie---</option>
                                              <option value = "A1">Auto</option>
                                              <option value = "D1">Moto</option>
                                              <option value = "C1">Camion Commerce</option>
                                          </select>   
                                        </div>
                                        </div>
                                        <div class="form-group row"> <label for="energie" class="col-form-label col-6">Energie</label>
                                          <div class="col-6">
                                          <select class="form-control" id="energie" name="energie" value={this.state.selectedDevis.energie} onChange={this.handleChange}>
                                              <option value="">---Energie---</option>
                                              <option value = "E">Essence</option>
                                              <option value = "D">Diesel</option>
                                              <option value = "H">Hybride</option>
                                              <option value = "T">Electrique</option>
                                          </select>                                        
                                          </div>
                                          </div>
                                        <div class="form-group row"> <label for="puissanceFiscale" class="col-form-label col-6">Puissance</label>
                                          <div class="col-6">
                                            <input type="text" class="form-control" id="puissanceFiscale" value  = {this.state.selectedDevis.puissanceFiscale}/> </div>
                                        </div>
                                        <div class="form-group row"> <label for="dateMEC" class="col-form-label col-6">Date MEC</label>
                                          <div class="col-6">
                                          <DatePicker className="form-control" dateFormat="dd/MM/yyyy" locale="fr" name="dateMEC" id="dateMEC" placeholderText="date de MEC" selected={this.state.selectedDevis.dateMEC}  onChange={this.handleDateMECChange}/>
                                          </div>
                                        </div>
                                        <div class="form-group row"> <label for="valeurNeuf" class="col-form-label col-6">valeur à neuf</label>
                                          <div class="col-6">
                                            <input type="text" class="form-control" id="valeurNeuf" name="valeurNeuf" value  = {this.state.selectedDevis.valeurNeuf} onChange={this.handleChange}/> </div>
                                        </div>
                                        <div class="form-group row"> <label for="valeurVenale" class="col-form-label col-6">valeur vénale</label>
                                          <div class="col-6">
                                            <input type="text" class="form-control" id="valeurVenale"  name="valeurVenale" value  = {this.state.selectedDevis.valeurVenale} onChange={this.handleChange}/> </div>
                                        </div>
                                        <div class="form-group row"> <label for="valeurGlaces" class="col-form-label col-6">valeur glaces</label>
                                          <div class="col-6">
                                            <input type="text" class="form-control" id="valeurGlaces" name="valeurGlaces" value  = {this.state.selectedDevis.valeurGlaces} onChange={this.handleChange}/> </div>
                                        </div>
                                        <button type="submit" class="btn btn-secondary">Valider</button>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="card">
                                    <div class="card-header">Informations sur vous</div>
                                    <div class="card-body p-1">
                                      <form id="c_form-h" class="">
                                        <div class="form-group row"> <label for="dateNaissance" class="col-form-label col-6">Date Naissance</label>
                                          <div class="col-6">
                                          <DatePicker className="form-control" dateFormat="dd/MM/yyyy" locale="fr" name="dateNaissance" placeholderText="date de naissance" selected={this.state.selectedDevis.dateNaissance} onChange={this.handleDateNaissanceChange}/>
                                           </div>
                                        </div>
                                        <div class="form-group row"> <label for="datePermis" class="col-form-label col-6">Date Permis</label>
                                          <div class="col-6">
                                          <DatePicker className="form-control" dateFormat="dd/MM/yyyy" locale="fr" name="datePermis" placeholderText="date de permis" selected={this.state.selectedDevis.datePermis} onChange={this.handleDatePermisChange}/>
                                           </div>
                                        </div>
                                        <div class="form-group row"> <label for="nombreSinistres" class="col-form-label col-6" contenteditable="true">Nombre de sinistres (durant les 3 dernières années)</label>
                                          <div class="col-6">
                                          <select class="form-control" id="nombreSinistres" name = "nombreSinistres" value={this.state.selectedDevis.nombreSinistres} onChange={this.handleChange}>
                                              <option value= "">---Nombre sinistres---</option>
                                              <option value= "0">0</option>
                                              <option value= "1">1</option>
                                              <option value= "2">2 et plus</option>
                                          </select>
                                        </div>
                                        </div>
                                        <button type="submit" class="btn btn-secondary">Valider</button>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-1">
                              <div class="card">
                                <div class="card-header">Garanties souscrites</div>
                                  <div class="card-body p-1">      
                                  <div class="table-responsive">
                                  <table class="table">
                                    <thead>
                                      <tr>
                                        
                                        <th>Garantie</th>
                                        <th>Valeur assurée</th>
                                        <th>Franchise</th>
                                        <th>Prime annuelle nette</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                    { this.state.selectedDevis.garanties.map((garantie,io) => (
                                      <tr key={garantie.code}>
                                      <td>  
                                        <div class="custom-control custom-checkbox">
                                          <input class="custom-control-input" type="checkbox" id={garantie.code} name={garantie.code} checked={this.state.selectedDevis.garanties[io].checked} onChange={() => this.handleGarChange2(io)} disabled = {garantie.code === "RC"} />
                                          <label class="custom-control-label" for={garantie.code}>
                                                  {garantie.libelle}
                                          </label>
                                         </div>
                                      </td>
                                      <td>{garantie.valeurAssuree}</td>
                                      <td>{garantie.franchise}</td>
                                      <td>{garantie.primeNette}</td>
                                      </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>
                                </div>
                                </div>
                              </div>
                              </React.Fragment>
                              )}
                             {!this.state.listeDevis ? <p class = "lead">{this.state.message}</p>:
                             (<React.Fragment>
                             <div class = "mt-3" style={{"border-bottom": "1px solid #57c4d0"}}><h5 class="">Liste des devis</h5>
                             </div>  
                              <div class="table-responsive mt-2">
                                <table class="table table-hover">
                                  <thead>
                                    <tr>
                                      <th scope="col">#</th>
                                      <th scope="col">Lob</th>
                                      <th scope="col">Etat</th>
                                      <th scope="col">Date création</th>
                                      <th scope="col">Date dernière modification</th>
                                      <th scope="col">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                                                          
                         { this.state.listeDevis.map(devis => (
                           <tr key={devis.idDevis}>
                           <td>{devis.idDevis}</td>  
                           <td>{devis.lob}</td>
                           <td>{devis.etat}</td>
                           <td>{devis.dateCreation}</td>
                           <td>{devis.dateModification}</td>
                           <td >
                           <button class="btn btn-outline-info" onClick={() => {this.modifierDevis(devis)}}  style={{marginLeft: '20px'}}> <i class="fa fa-pencil"></i></button>
                           <button class="btn btn-outline-danger" onClick={() => {this.modifierDevis(devis)}}  style={{marginLeft: '20px'}}> <i class="fa fa-trash-o"></i></button>

                            </td>
                           </tr>
                            ))}
  
                                   
                                  </tbody>
                                </table>
                              </div>
                              </React.Fragment>
                              )}
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane fade" id="tabone" role="tabpanel">
                          <div class="row">
                            <div class="col-md-6">
                              <form id="c_form-h" class="">
                                <div class="form-group row"> <label for="username" class="col-3 col-form-label">Nom d'utilisateur</label>
                                  <div class="col-9">
                                    <input type="text" class="form-control" id="username" name="username" placeholder="Nom utilisateur"/> </div>
                                </div>
                                <div class="form-group row"> <label for="name" class="col-3 col-form-label">Nom</label>
                                  <div class="col-9">
                                    <input type="text" class="form-control" id="name" name="name" placeholder="Nom utilisateur"/> </div>
                                </div>

                              </form><button type="submit" class="btn btn-light">Modifier</button><a class="btn btn-secondary mx-1" href="{#}">Valider</a>
                            </div>
                            <div class="col-md-6">
                              <form id="c_form-h" class="">
                              <div class="form-group row"> <label for="email" class="col-3 col-form-label">Email</label>
                                  <div class="col-9">
                                    <input type="email" class="form-control" id="email"  name="email"  placeholder="exemple@mail.com"/> </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane fade text-center" id="tabfive" role="tabpanel">
                          <p class="text-danger">Cette action est irrevocable !</p><a class="btn btn-danger" href="{#}">Supprimer mon compte</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </React.Fragment>
                )}
           
          </React.Fragment>
        
        );
    }

}


export default PSpaceComponent;